















































































































































import { Component, Vue } from 'vue-property-decorator'
import packageJsonData from '../../package.json'

const menuItems = [
  {
    icon: 'mdi-alpha-i-box-outline',
    title: 'Introduction',
    path: '/home/introduction',
    appendIcon: null,
    active: true
  },
  {
    icon: 'mdi-alpha-g-box-outline',
    title: 'Guide',
    path: '/home/guide',
    appendIcon: null
  },
  {
    icon: 'mdi-alpha-d-box-outline',
    title: 'D3',
    path: '/home/d3',
    appendIcon: null
  },
  {
    icon: 'mdi-alpha-q-box-outline',
    title: 'Quill',
    path: '/home/quill',
    appendIcon: null
  },
  {
    icon: 'mdi-alpha-t-box-outline',
    title: 'Table',
    children: [
      { title: 'users', path: '/table/users' },
      { title: 'simple tables', path: '/table/simple-table' }
    ],
    appendIcon: 'mdi-chevron-down'
  },
  {
    icon: 'mdi-alpha-i-box-outline',
    title: 'Icons',
    children: [
      { title: 'iconfont', path: '/icons/iconfont' },
      { title: 'materialdesignicons', path: '/icons/materialdesignicons' }
    ],
    appendIcon: 'mdi-chevron-down'
  },
  {
    icon: 'mdi-alpha-c-box-outline',
    title: 'Charts',
    children: [
      { title: 'ECharts', path: '/charts/echarts' },
      // { title: 'Vega Charts', path: '/charts/vega-charts' },
      { title: 'D3 Charts', path: '/charts/d3-charts' },
      { title: 'Highcharts', path: '/charts/high-charts' }
    ],
    appendIcon: 'mdi-chevron-down'
  },
  {
    icon: 'mdi-alpha-m-box-outline',
    title: 'Maps',
    children: [
      { title: 'openlayers', path: '/maps/openlayers' },
      { title: 'openseadragon', path: '/maps/openseadragon' },
      { title: 'leaflet', path: '/maps/leaflet' },
      { title: 'leaflet-marker', path: '/maps/leaflet-marker' },
      { title: 'leaflet-heat-map', path: '/maps/leaflet-heat-map' },
      { title: 'leaflet-heat-map-2', path: '/maps/leaflet-heat-map-2' },
      { title: 'baidu map', path: '/maps/baidu-map' }
    ],
    appendIcon: 'mdi-chevron-down'
  },
  {
    icon: 'mdi-alpha-s-box-outline',
    title: 'Schema',
    children: [
      { title: 'Vuetify JSON Schema', path: '/schema/vuetifyjsonschema' }
    ],
    appendIcon: 'mdi-chevron-down'
  },
  {
    icon: 'mdi-alpha-m-box-outline',
    title: 'Markdown',
    children: [{ title: 'showdownjs', path: '/markdown/showdown' }],
    appendIcon: 'mdi-chevron-down'
  },
  {
    icon: 'mdi-alpha-h-box-outline',
    title: 'Highlight',
    children: [{ title: 'prism', path: '/highlight/prism' }],
    appendIcon: 'mdi-chevron-down'
  },
  {
    icon: 'mdi-alpha-d-box-outline',
    title: 'Drag',
    children: [{ title: 'vue-draggable', path: '/drag/vue-draggable' }],
    appendIcon: 'mdi-chevron-down'
  }
]

@Component({
  components: {}
})
export default class Home extends Vue {
  private publicPath: string = process.env.BASE_URL
  private version: string = '0.1.0'
  private dialog: boolean = false
  private modalDialog: boolean = false
  private dark: boolean = false
  private drawer: boolean = true
  private fullScreenFlag: boolean = false

  private itemActive: number = 0
  private subItemActive: number = 0
  private items = menuItems
  private userInfo: object = {
    username: 'username',
    avatar: '/img/avatar.png'
  }

  private created() {
    if (this.publicPath === '/') {
      this.publicPath = ''
    } else {
      this.publicPath = '/vue-vuetify-admin'
    }
    this.version = packageJsonData.version
    if (
      localStorage.getItem('themeDark') &&
      localStorage.getItem('themeDark') === 'true'
    ) {
      this.$vuetify.theme.dark = true
      this.dark = true
    }
    if (this.$route.path === '/home') {
      this.$router.push('/home/introduction').catch((err) => {}) // tslint:disable-line
    } else {
      this.$router.push(this.$route.path).catch((err) => {}) // tslint:disable-line

      if (sessionStorage.getItem('itemActive')) {
        this.items[0].active = false
        this.items[Number(sessionStorage.getItem('itemActive'))].active = true
      }

      if (sessionStorage.getItem('subItemActive')) {
        this.subItemActive = Number(sessionStorage.getItem('subItemActive'))
      }
    }
  }

  private mounted() {
    if (
      sessionStorage.getItem('userInfo') &&
      sessionStorage.getItem('userInfo') !== ''
    ) {
      this.userInfo = JSON.parse(String(sessionStorage.getItem('userInfo')))
    }

    const self = this
    document.addEventListener('fullscreenchange', () => {
      self.fullScreenFlag = !self.fullScreenFlag
    })
  }

  private beforeDestroy() {
    sessionStorage.removeItem('subItemActive')
    sessionStorage.removeItem('itemActive')
  }

  private requestFullscreen() {
    const docElm: any = document.documentElement
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen()
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen()
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen()
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen()
    }
  }

  private exitFullScreen() {
    const docWithBrowsersExitFunctions: any = document as Document & {
      mozExitFullScreen(): Promise<void>
      webkitExitFullscreen(): Promise<void>
      msExitFullscreen(): Promise<void>
    }
    if (docWithBrowsersExitFunctions.exitFullscreen) {
      docWithBrowsersExitFunctions.exitFullscreen()
    } else if (docWithBrowsersExitFunctions.msExitFullscreen) {
      docWithBrowsersExitFunctions.msExitFullscreen()
    } else if (docWithBrowsersExitFunctions.mozExitFullScreen) {
      docWithBrowsersExitFunctions.mozExitFullScreen()
    } else if (docWithBrowsersExitFunctions.webkitExitFullScreen) {
      docWithBrowsersExitFunctions.webkitExitFullScreen()
    }
  }

  private openTab() {
    window.open('https://github.com/gywgithub/vue-vuetify-admin', '_blank')
  }

  private usernameClick() {
    console.info('')
  }

  private itemClick(item: any, key: string) {
    this.subItemActive = -1
    sessionStorage.setItem('itemActive', key)
    if (item.path !== '') {
      this.$router.push(item.path).catch((err) => {}) // tslint:disable-line
    }
  }

  private subItemClick(item: any, key: string) {
    sessionStorage.setItem('subItemActive', key)
    this.$router.push(item.path).catch((err) => {}) // tslint:disable-line
  }

  private goHome() {
    this.$router.push('/Home').catch((err) => {}) // tslint:disable-line
  }

  private changeTheme() {
    this.dark = !this.dark
    localStorage.setItem('themeDark', String(this.dark))
    this.$vuetify.theme.dark = this.dark
  }

  private logout() {
    sessionStorage.clear()
    localStorage.clear()
    this.$router.replace({ path: '/login' })
  }
}
